"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedSiteTree = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-empty-interface */
const react_1 = __importStar(require("react"));
const lodash_1 = __importStar(require("lodash"));
const recoil_1 = require("recoil");
const EmbedReportPage_1 = require("../EmbeddedReports/EmbedReportPage");
const antd_1 = require("antd");
const EmbedSiteTree = ( /* {}: Props */) => {
    const treeData = (0, recoil_1.useRecoilValue)(EmbedReportPage_1.siteTreeState);
    const [selected, setSelected] = (0, recoil_1.useRecoilState)(EmbedReportPage_1.internalSelectedSiteNodesState);
    const [, setSelectedSiteIds] = (0, recoil_1.useRecoilState)(EmbedReportPage_1.selectedSiteIdsState);
    const embedInternalSiteIds = (0, recoil_1.useRecoilValue)(EmbedReportPage_1.embedInternalSiteIdsState);
    const [, setSyncExternalSiteFilter] = (0, recoil_1.useRecoilState)(EmbedReportPage_1.syncExternalSiteFilterState);
    let previouslySelectedSiteNode;
    const debouncedSelectedSites = (0, react_1.useMemo)(() => {
        return lodash_1.default.debounce(() => {
            const ids = selected?.map((x) => x.value);
            setSyncExternalSiteFilter(typeof ids !== 'undefined' &&
                embedInternalSiteIds?.slice().sort().join(',') !==
                    ids?.slice().sort().join(','));
            setSelectedSiteIds(ids ?? []);
        }, 1500);
    }, [selected, setSelectedSiteIds]);
    const onChange = (value) => {
        setSelected(value);
    };
    const preventRemovingItemsWhenBackspaced = (e) => {
        if (e.key === 'Backspace')
            e.stopPropagation();
    };
    const selectAllChildNodes = (node) => getAllParentChildNodes(node);
    const getAllParentChildNodes = (data) => {
        const nodes = [];
        nodes.push({
            value: data.key,
            label: data.title,
        });
        data.children?.map((node) => {
            nodes.push({
                value: node.key,
                label: node.title,
            });
            if (node.children)
                nodes.push(...(0, lodash_1.flattenDeep)(node.children.map(getAllParentChildNodes)));
        });
        return nodes;
    };
    const filterTreeNode = (inputValue, option) => option?.title
        ?.toLowerCase()
        .indexOf(inputValue.toLowerCase()) >= 0;
    const containInputValue = (query, data, parentNode) => {
        const nodes = [];
        data.map((node) => {
            if (node.title.toLowerCase().includes(query)) {
                if (!nodes.includes(parentNode) && parentNode.key !== treeData[0].key) {
                    const parent = {
                        key: parentNode.key,
                        title: parentNode.title,
                        children: [node],
                    };
                    return nodes.push(parent);
                }
                return nodes.push(node);
            }
            if (node.children?.length) {
                nodes.push(...containInputValue(query, node.children, node));
            }
        });
        return nodes;
    };
    (0, react_1.useEffect)(() => {
        debouncedSelectedSites();
        return () => {
            debouncedSelectedSites.cancel();
        };
    }, [debouncedSelectedSites]);
    const defaults = {
        bordered: true,
        style: {
            width: 'inherit',
        },
        notFoundContent: (react_1.default.createElement("div", { className: 'p-20 text-center' }, /* Translator.getItem('no_sites_found') */ 'No sites found')),
        onChange,
        onInputKeyDown(e) {
            preventRemovingItemsWhenBackspaced(e);
        },
        onClick: (e) => {
            const target = e.target;
            if (target.classList.contains('ant-select-tree-checkbox') ||
                target.classList.contains('ant-select-tree-checkbox-inner')) {
                const isChecked = target.classList.contains('ant-select-tree-checkbox-checked');
                const allChildNodes = previouslySelectedSiteNode
                    ? selectAllChildNodes(previouslySelectedSiteNode)
                    : [];
                if (!isChecked) {
                    allChildNodes?.push(...selected);
                    return onChange(allChildNodes ?? []);
                }
                const difference = lodash_1.default.differenceBy(selected, allChildNodes, 'value');
                onChange(difference);
            }
        },
        onDeselect: (value, option) => {
            previouslySelectedSiteNode = option;
        },
        onSelect: (value, option) => {
            previouslySelectedSiteNode = option;
        },
        treeCheckStrictly: true,
        filterTreeNode,
        allowClear: true,
        showSearch: true,
        showAction: ['click'],
        value: selected ?? undefined,
        treeData,
        treeCheckable: true,
        maxTagCount: 'responsive',
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { style: { alignSelf: 'center', width: '20%' }, className: 'm-right15 hidden-sm hidden-xs' }, /* Translator.getItem('filter_by_site') */ 'Filter by site'),
        react_1.default.createElement(antd_1.TreeSelect, { ...defaults })));
};
exports.EmbedSiteTree = EmbedSiteTree;
exports.default = exports.EmbedSiteTree;
